import apiClient from './client';

export interface LeadershipDashboard {
  totalLeads: number;
  totalAccounts: number;
}

export interface BDDashboard {
  myLeads: number;
}

export interface StrategyCreativeDashboard {
  sowVersions: any[];
  deckStats: any;
  commercialStats: any;
  sowCycleStats: any[];
}

export interface DeliveryDashboard {
  kickoffStatus: any[];
  pendingBilling: any[];
  overdueInvoices: any[];
  deliveryRisks: any[];
}

export const dashboardsApi = {
  getLeadership: async (): Promise<LeadershipDashboard> => {
    const response = await apiClient.get<{ success: boolean; data: LeadershipDashboard }>('/dashboards/leadership');
    return response.data.data;
  },
  getBDPersonal: async (): Promise<BDDashboard> => {
    const response = await apiClient.get<{ success: boolean; data: BDDashboard }>('/dashboards/bd-personal');
    return response.data.data;
  },
  getStrategyCreative: async (): Promise<StrategyCreativeDashboard> => {
    const response = await apiClient.get<{ success: boolean; data: StrategyCreativeDashboard }>('/dashboards/strategy-creative');
    return response.data.data;
  },
  getDelivery: async (): Promise<DeliveryDashboard> => {
    const response = await apiClient.get<{ success: boolean; data: DeliveryDashboard }>('/dashboards/delivery');
    return response.data.data;
  },
};

